import React from 'react'
import Header from './../../../header/header'
import styled from 'styled-components'
import videos_list from './../Astrovideolist'
import 'video-react/dist/video-react.css'
import { Player } from 'video-react'
const VideoContainer = styled.div`
    margin-top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: black;
`

const RelatedVideosMobile = styled.div`
    margin-top: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
`

const TitleMobile = styled.div`
    font-size: 20px;
    color: white;
    margin-bottom: 1rem;

`

const VideoDetail = styled.div`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    img{
        width: 100px;
        height: 60px;
        object-fit: contain;
    }
    div{
        font-size: 12px;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`

const Card = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    img{
        object-fit: cover;
        height: auto;
        width: 100%;
        border-radius: 10px;
    }
    div{
        position: absolute;
        font-size: 32px;
        right: 8px;
        bottom: 5px;
        display: none;
    }
    :hover{
        div{
            display: block;
        }
    }
`

const RelatedVideosDesktop = styled.div`
    font-size: 24px;
    color: white;
    padding-left: 20px;
    padding-top: 10px;
`


const isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};


class VideoPlayer extends React.Component{
    state = {
        currVideo: videos_list.filter(x => x.id === parseInt(this.props.match.params.id))[0]
    }
    componentDidMount() {
        window.scrollTo(0,0)
    }

    onClickHandler = (id) => {
        this.props.history.push(`/video-play/${id}`)
        let newvid = videos_list.filter((item) => {
            return item.id === parseInt(id)
        })[0]
        this.setState({
            currVideo: newvid
        })
    }
    
    render() {
        return (
            <div>
            <Header />
            <VideoContainer key={this.state.currVideo}>
                <Player playsInline poster={this.state.currVideo.preview} src={this.state.currVideo.videourl} fluid={isMobile.any() ? true : false} height={450} autoPlay={true} />
            </VideoContainer>
            {isMobile.any() ? <RelatedVideosMobile>
                <TitleMobile>Related Videos</TitleMobile>
                {videos_list.map((item) => {
                    if(item.id !== parseInt(this.props.match.params.id)) return(
                        <VideoDetail key={item.id} onClick={() => {this.onClickHandler(item.id)}}>
                            <img src={item.preview} alt={item.name} />
                            <div>
                                <span>{item.name}</span>
                                <span>
                                    <i className="fa fa-play-circle"></i>
                                </span> 
                            </div>
                    </VideoDetail>
                    )
                })}
            </RelatedVideosMobile> 
            : 
            <div>
            <RelatedVideosDesktop>
                Related Videos
            </RelatedVideosDesktop>
             <div className="row" style={{padding: '20px'}}>
             {videos_list.map((x) => {
                 if(x.id !== this.props.match.params.id) return(
                     <div className="col-md-3 col-sm-12 col-xs-12" style={{margin: '10px 0px', display: 'flex', justifyContent: 'center'}}>
                     <Card onClick={() => {this.onClickHandler(x.id)}}>
                         <img src={x.preview} alt={x.name} />
                         <div>
                             <i className="fa fa-play"></i>
                         </div>
                     </Card>
                     </div>
                 )
             })}
             </div>
             </div>
             }
            </div>
        )
    }
}

export default VideoPlayer; 


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/Astrovideos/VideoPlayer/VideoPlayer.js